import {  memo  , useCallback , useState} from 'react';
import ListItem from '@mui/material/ListItem';
import {Box} from '@mui/material';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import { useTranslation } from "react-i18next";

const MapListItemHistory = memo((props) => {
    const {histories , selectHistory} = props;
    const [openDescriptionId , setOpenDescriptionId] = useState(null);
    const { t } = useTranslation();

    const nl2comma = useCallback((str) => {
        return str.replaceAll("¥/", "、");
    },[]);
    const canDisplayDescription = useCallback((history) => {
        if(!history){
            return false;
        }
        return history.description !== '';
    },[]);

    const toggleOpenDescription  = (historyId) => {
        if(openDescriptionId === historyId){
            setOpenDescriptionId(null);
        }else{
            setOpenDescriptionId(historyId);
        }
    }

    return (
        histories.map((history, index) => 
            <ListItem alignItems="flex-start" key={index}>
            <Card className={"historyListItem"}>
                <Box sx={{display:'flex'}}>
                    <CardMedia
                        component="img"
                        sx={{ width: 140 }}
                        image={"/assets/images/descriptions/" + history.path}
                    />
                    <Box sx={{ display: 'block'}}>
                    <CardContent sx={{ flex: '1 0 auto' }}>
                        <Typography component="div" variant="h5" className="title">
                            {history.name}
                        </Typography>
                        <Typography variant="subtitle1" component="div" sx={{ color: 'text.secondary', overflowWrap: 'break-word' }}>
                            {nl2comma(history.subtitle)}
                        </Typography>
                    </CardContent>
                    </Box>
                </Box>
                {canDisplayDescription(history.description) && openDescriptionId === history.id?
                    <Box className='description' id={`description_${history.id}`}>
                        {history.description}
                    </Box>:<></>
                    }
                <Box className='btnWrap'>
                    <Button variant="contained" onClick={() => selectHistory(history)} >
                    {t("common.btn_on_map")}
                    </Button>
                    {canDisplayDescription(history.description)?
                    <Button variant="outlined" onClick={() => toggleOpenDescription(history.id)} key={history.id}>
                        {openDescriptionId === history.id?<>{t("common.btn_close_detail")}</>:<>{t("common.btn_open_detail")}</>}
                    </Button>
                    :<></>
                    }
                </Box>
            </Card>
            </ListItem>
        )
    )
});
export default MapListItemHistory